<div class="suggest-wrapper suggested-cases">
  <app-suggested-case *ngFor="let item of suggestedCases" [caseId]="item.id" [patientName]="item.patient"></app-suggested-case>
</div>
